"use client";
import React from "react";
import { RichText } from "~/use-cases/contracts/RichText";
import LipscoreServiceSmall from "../aplia/Lipscore/LipScoreServiceSmall";
import { RichTextRenderer } from "~/ui/components/rich-text-renderer";

export const Ticker: React.FC<{
  ticker: RichText;
}> = ({ ticker }) => {
  return (
    <div className="ticker flex flex-row justify-center items-center gap-4 h-[42px]">
      <LipscoreServiceSmall />{" "}
      {ticker.plainText && ticker.plainText !== "" && "|"}
      <RichTextRenderer json={ticker.json} />
    </div>
  );
};
